<template>
  <ButtonDefinitive
    v-if="lstDestination.length === 0"
    label="Continuar"
    @click="next"
  />
  <div v-else class="c-nav c-nav--floating-footer-sticky__spaceButtonPair">
    <ButtonDefinitive
      label="Siguiente"
      :isDisabled="hasIncompatiblePackages"
      @click="next"
    />
    <ButtonDefinitive
      variant='tertiary'
      label="Agregar otro paquete"
      @click="addDestinationAddress()"
    />
  </div>
</template>

<script>
import {
  readFilePSDropOff,
  readFilePSPickUp,
} from "../../../services/massiveLoad";
import {  getScharffPointFare} from "../../../services/fare"
import ButtonDefinitive from '@/components/Button/ButtonDefinitive.vue'

export default {
  name: "Step3-Footer",
  components: { ButtonDefinitive },
  mounted() {
    this.$nextTick(() => {});
  },
  methods: {
    addDestinationAddress() {
      this.$store.dispatch(
        "SCHARFFPOINT_ORDER_SET_INDEX_DESTINATION",
        this.lstDestination.length
      );
      this.$eventBus.$emit("scharffPointClearDataDestinationModal");
      const modalpackage = document.querySelector("#modal-package");
      modalpackage.classList.add("is-active");
      this.$emit("getDefaultContact");
      document.getElementById("scharffPoint-step-3-modal-pop").value = "";

      this.trackEvent('click_puntos_envia_paso_3_agregar_otro_paquete', 'dropoff/puntoapunto')
    },
    async calculateFare(data) {
      const fareRequest = {
        PackageValue: data.productValue,
        PackageWidth: data.packageSize.width,
        PackageHeight: data.packageSize.height,
        PackageDeep: data.packageSize.lengths,
        PackageWeight: data.packageSize.weight,
        PackageType: data.packageSize.type,
        isMoreThan10: false,
        IsServiceExpress: false,
        IsServiceProgrammed: false,
        isServiceScharffPoint: true,
        OriginDistrictId: this.origin.districtId.id,
        DestinationDistrictId: data.destinationAddress.districtId.id,
        ProgrammedServiceDate: null,
        IsUsingSubscription: false,
      };
      
      const  fareResponse = await getScharffPointFare(fareRequest);
      // await this.$store
      //   .dispatch("POST_CALCULATE_FARE", fareRequest)
      //   .then((success) => {
      //     if (success.status === 200) {
      //       fareResponse = success.data.result;
      //     } else {
      //       this.showError(success.data.message);
      //       fareResponse = null;
      //     }
      //   })
      //   .catch((error) => {
      //     const catchMsg = this.catchStandardErrorMsg(error);
      //     this.showError(catchMsg);
      //     fareResponse = null;
      //   });

      return fareResponse;
    },
    async getDepProDisByText(department, province, district) {
      const payload = {
        departamento: department,
        provincia: province,
        distrito: district,
      };

      let res = null;
      await this.$store
        .dispatch("GET_EXCEL_DEP_PRO_DIS", payload)
        .then((success) => {
          if (success.status === 200) {
            res = success.data.result;
          } else {
            this.showError(success.data.message);
            res = null;
          }
        })
        .catch((error) => {
          const catchMsg = this.catchStandardErrorMsg(error);
          this.$swal.close();
          this.showError(catchMsg);
          res = null;
        });

      return res;
    },
    async getScharffPointById(id) {
      let valid = false;
      let scharffPoint = null;
      await this.$store
        .dispatch("GET_SCHARFF_POINT_BY_ID", id)
        .then((success) => {
          if (success.status === 200) {
            valid = true;
            scharffPoint = success.data.result;
          } else {
            this.showError(success.data.message);
          }
        })
        .catch((error) => {
          const catchMsg = this.catchStandardErrorMsg(error);
          this.$swal.close();
          this.showError(catchMsg);
        });

      if (valid === true) {
        return scharffPoint;
      }
      return null;
    },
    async next() {
      
      this.showLoading(
        // eslint-disable-next-line max-len
        "Estamos creando tu pedido. Ten en cuenta que esto puede tardar varios segundos más dependiendo de la cantidad de destinos."
      );
      // The file stays in the store once parsed; re-parsing would discard the user's corrections.
      if (this.file && this.lstDestination.length <= 0) {
        this.$store.dispatch("SCHARFFPOINT_CLEAR_DESTINATION");
        let valid = false;
        let destinations = null;
        const serviceToCall = this.order.type == 1 ? readFilePSDropOff : readFilePSPickUp
        const formData = new FormData();
        this.file.forEach((f) => {
          formData.append("file", f);
          formData.append("originDistrict", this.origin.districtId.id);
          formData.append("userId", this.user?.id || null);
          if (this.origin.scharffPoint?.ScharffPointId) {
            formData.append("originScharffPointId", this.origin.scharffPoint.ScharffPointId);
          }
        });
        const response = await serviceToCall(formData);
        if (response.status === 200) {
          valid = true;
          destinations = response.data;
          this.trackEvent('click_puntos_envia_paso_3_plantilla_continuar', 'dropoff/puntoapunto')
        } else {
          this.showError(response.data.message);
          this.trackEvent('click_puntos_envia_paso_3_plantilla_continuar_failed', 'dropoff/puntoapunto')
        }

        if (valid === true) {
          await this.$store.dispatch('SCHARFFPOINT_APPEND_DESTINATION_FROM_EXCEL', destinations)
          if (this.hasIncompatiblePackages) {
            this.showWarning(this.incompatiblePackagesMessage)
            return
          }
          // const sumAll = this.lstDestination
          //   .filter(item => !item.isShippingPaidAtDestination)
          //   .map(item => item.fare)
          //   .reduce((prev, curr) => prev + curr, 0);
          // this.$store.dispatch("SCHARFFPOINT_FARE", sumAll);
          this.$store.dispatch("SCHARFFPOINT_PROGRESS_NAV_STEP", 4);
          this.$swal.close();
        }
      } else if (this.validateData()) {
        this.$store.dispatch("SCHARFFPOINT_PROGRESS_NAV_STEP", 4);
        const sumAll = this.lstDestination
          .filter(item => !item.isShippingPaidAtDestination)
          .map(item => item.fare)
          .reduce((prev, curr) => prev + curr, 0);
        this.$store.dispatch("SCHARFFPOINT_FARE", sumAll);
        this.$swal.close();

        this.trackEvent('click_puntos_envia_paso_3_continuar', 'dropoff/puntoapunto')
      } else {
        if (!this.hasIncompatiblePackages) {
          this.showError("Agrega un paquete como mínimo.");
        }
      }
    },
    validateData() {
      if (this.hasIncompatiblePackages) {
        this.showWarning(this.incompatiblePackagesMessage);
        return false;
      }
      const list = this.$store.getters.SCHARFFPOINT_ORDER_DESTINATION;
      if (list.length === 0) {
        return false;
      }
      return true;
    },
  },
  computed: {
    lstDestination() {
      return this.$store.getters.SCHARFFPOINT_ORDER_DESTINATION;
    },
    file() {
      return this.$store.getters.SCHARFFPOINT_FILE;
    },
    origin() {
      return this.$store.getters.SCHARFFPOINT_ORDER_ORIGIN;
    },
    order() {
      return this.$store.getters.SCHARFFPOINT_ORDER;
    },
    user() {
      return this.$store.getters.USER;
    },
    hasIncompatiblePackages() {
      return this.$store.getters.SCHARFFPOINT_HAS_INCOMPATIBLE_PACKAGES;
    },
    incompatiblePackagesMessage() {
      return this.$store.getters.SCHARFFPOINT_INCOMPATIBLE_PACKAGES_MESSAGE;
    }
  },
};
</script>

<style></style>
